import styled, { css } from 'styled-components';
import { omitProps } from '../../helpers/omitProps.js';
import { Clickable } from '../../InternalComponents/Clickable/Clickable.js';
import { SonntagIcon } from '../../SonntagIcon/SonntagIcon.js';
import { elevationTransition, elevation } from '../../Styles/Utils/elevation.js';

const IconWrapper = styled.div.withConfig({
    displayName: "styled__IconWrapper",
    componentId: "sc-35bc4b6e-0"
})`
    margin: 0 6px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    ${elevationTransition}

    & > svg {
        width: 24px;
        height: 24px;
        padding: 0;
        fill: ${({ theme , color  })=>color || theme.colors.Foreground};
    }

    & * {
        fill: ${({ theme , color  })=>color || theme.colors.Foreground};
    }

    ${({ onlyIcon  })=>onlyIcon && css`
            margin: 0 -6px;
        `};
`;
const ButtonView = omitProps("fullWidth", "outlined", "size", "theme", "accentColor", "withIcon", "onlyIcon", "solid")(Clickable);
const StyledButton = styled(ButtonView).withConfig({
    displayName: "styled__StyledButton",
    componentId: "sc-35bc4b6e-1"
})`
    ${(props)=>css(props.theme.typography.SmallHeadline)};
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    height: ${({ size  })=>size && size === "small" && "32px" || "48px"};
    background-color: ${({ theme  })=>theme.colors["Level 1"]};
    background-clip: ${({ solid  })=>solid ? "border-box" : "padding-box"};
    border-radius: ${({ size  })=>size && size === "small" && "16px" || "24px"};
    border-style: solid;
    border-width: 2px;
    border-color: ${({ theme  })=>theme.colors["Level 1"]};
    min-width: 0;
    color: ${({ theme  })=>theme.colors.Foreground};
    overflow: hidden;
    outline: none;
    padding: ${({ withIcon , size , onlyIcon  })=>withIcon && size === "small" && onlyIcon && "0 8px" || withIcon && size === "small" && !onlyIcon && "0 8px 0 4px" || withIcon && !size && "0 16px" || !withIcon && size === "small" && "0 16px" || "0 24px"};
    ${elevationTransition}

    &:visited {
        text-decoration: none;
    }

    &:disabled {
        transition: none;
        transform: none;
        opacity: 0.4;
        cursor: default;
    }

    &:hover:not(:disabled) {
        cursor: pointer;
        background-color: ${({ theme  })=>theme.colors.HoverBackground};
        border-color: ${({ theme  })=>theme.colors.HoverBackground};
        background-clip: padding-box;
        ${elevation(2, false)}
    }

    &:active:not(:disabled) {
        text-decoration: none;
        ${elevation(1, false)};
        transition-duration: 0s;
        background-color: ${({ theme  })=>theme.colors.ElementBackground};
        border-color: ${({ theme  })=>theme.colors.ElementBackground};
        background-clip: padding-box;
    }

    ${({ accentColor , theme , solid , outlined  })=>accentColor && css`
            color: ${accentColor && solid && !outlined ? "#fff" : accentColor};
            background-color: ${accentColor && solid && !outlined && accentColor || accentColor && outlined && !solid && "transparent" || theme.colors["Level 1"]};
            border-color: ${(solid || outlined) && accentColor || theme.colors["Level 1"]};

            & > svg,
            & * {
                fill: ${accentColor && solid && !outlined ? "#fff" : accentColor};
            }

            &:hover:not(:disabled) {
                color: ${theme.colors.Foreground};
                background-color: ${theme.colors.HoverBackground};
                border-color: ${theme.colors.HoverBackground};

                & > svg,
                & * {
                    fill: ${theme.colors.Foreground};
                }
            }

            &:active:not(:disabled) {
                color: ${theme.colors.Foreground};
                background-color: ${theme.colors.ElementBackground};
                border-color: ${theme.colors.ElementBackground};
                & > svg,
                & * {
                    fill: ${theme.colors.Foreground};
                }
            }
        `};

    ${({ outlined  })=>outlined && css`
            background-color: transparent;
        `};

    ${({ fullWidth  })=>fullWidth && css`
            width: 100%;
        `};
`;
const StyledSonntagIcon = styled(SonntagIcon).withConfig({
    displayName: "styled__StyledSonntagIcon",
    componentId: "sc-35bc4b6e-2"
})`
    margin: 0 6px 0 0;

    ${({ onlyIcon  })=>onlyIcon && css`
            margin: 0 -6px;
        `};
`;
const RippleContainer = styled.div.withConfig({
    displayName: "styled__RippleContainer",
    componentId: "sc-35bc4b6e-3"
})`
    width: 100%;
    height: 100%;
    position: absolute !important;
    top: 0;
    left: 0;
`;
const TruncationWrapper = styled.div.withConfig({
    displayName: "styled__TruncationWrapper",
    componentId: "sc-35bc4b6e-4"
})`
    vertical-align: center;
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    -webkit-line-clamp: 1;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export { IconWrapper, RippleContainer, StyledButton, StyledSonntagIcon, TruncationWrapper };
